import { AbgSxProps } from '@abg/typings';

export const rateTermsNotesCommonStyling: AbgSxProps = {
  fontSize: 'inherit',
};
